import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  PropsWithChildren,
} from 'react';

/* Redux */
import { useDispatch } from 'react-redux';
import { dashboardActions } from '../../store/dashboard/actions';

interface TipsterFeeTiersContent {}

const TipsterFeeTiersContext = createContext<TipsterFeeTiersContent>(
  {} as TipsterFeeTiersContent,
);

export const TipsterFeeTiersProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(dashboardActions.tipsterFeeTiersRequestAction({}));
  }, []);

  return (
    <TipsterFeeTiersContext.Provider value={{}}>
      {children}
    </TipsterFeeTiersContext.Provider>
  );
};

export const useTipsterFeeTiersContext = () =>
  useContext(TipsterFeeTiersContext);
